module.exports = __webpack_public_path__ + "949b9090ac258d12d70c223c1780da4a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/common/70-20-learn.png
 ** module id = 832
 ** module chunks = 0
 **/